<div style="margin-left: 20px; margin-right: 20px">
  <div class="message-header">
    <div style="font-weight: bold">
      {{ author() }}
      <span
        style="margin-left: 3px; font-weight: normal; color: rgb(170, 170, 170)"
        [ngStyle]="{
          color: message.isAdmin ? 'rgb(231, 199, 136)' : 'rgb(185, 212, 157)'
        }"
        >{{ from() }}</span
      >
    </div>
    <div>{{ message.createdAt | timeAgo }}</div>
  </div>
  <div class="mt-1" [innerHtml]="message.detail"></div>
</div>
